import i18n from '@/i18n';

interface dataToResponseAlertI {
  ok: boolean;
  status: number;
  data: {
    message: string;
    description: string;
  };
}

const passDataToResponseAlert = async (response: Response): Promise<dataToResponseAlertI> => {
  const responseJson = await response.json();

  let detail = checkForDetailedDescription(responseJson.detail);

  if (response.status >= 500) {
    detail = i18n.t('somethingWrongWithOurServer');
  }

  return {
    ok: response.ok,
    status: response.status,
    data: {
      message: responseJson.title,
      description: detail,
    },
  };
};

const registeredUserResponsesFromBE = [
  'User onboarding state mismatch',
  'This User is already registerd',
  'email: This value is already used',
];

const checkForDetailedDescription = (detail) => {
  if (registeredUserResponsesFromBE.some((resp: string) => resp.includes(detail))) {
    return i18n.t('thisEmailHasBeenAlreadyTaken');
  }

  return detail;
};

export default passDataToResponseAlert;
